import { createAction, props } from '@ngrx/store';

export const setDgExerciseServiceDisruptionHyperwallet = createAction(
  '[FeatureFlag] Set DG Exercise Service Disruption Hyperwallet',
  props<{ dgExerciseServiceDisruptionHyperwallet: boolean }>(),
);
